export default __webpack_public_path__ + "static/media/logo-ilmugiziku.3dbc5b01.png";